import { RootStateType } from '.';

export const getRouterHistory = (state: RootStateType): any => {
	return state.router.history;
};
